import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ThemePalette } from '@angular/material/core';
import { TextType } from '..';
import { ColorTheme } from '@app/eds/constants';
import { ICheckboxSelectionData, SharedConstants, TextStyleTypes } from '@app/eds';

@Component({
  selector: 'app-checkbox[checkboxData][checkboxCheck]',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  //checkboxData provide the data for the checkbox field i.e. male/female, yes/no.
  @Input() checkboxData: string = SharedConstants.EMPTY_STRING;

  // Font style input props like font weight, font color, font size.
  @Input() fontType: TextType = TextStyleTypes.BODY;

  // Whether the checkboz is selected by default or not
  @Input() defaultChecked = false;

  // Whether the checkbox is disabled
  @Input() isDisabled = false;

  // Unique id for the checkbox
  @Input() checkboxId: string = SharedConstants.EMPTY_STRING;

  // This props handle the change event.
  @Output() checkboxCheck: EventEmitter<ICheckboxSelectionData> =
    new EventEmitter<ICheckboxSelectionData>();

  // Default Checkbox Color
  defaultColor: ThemePalette = ColorTheme.Primary as ThemePalette;

  /**
   * This method is triggered when a checkbox value is checked or unchecked.
   *
   * @param {MatCheckboxChange} isCheckedBool checkbox data
   */
  onChange = (isCheckedBool: MatCheckboxChange): void =>
    this.checkboxCheck.emit({
      isCheckedBool: isCheckedBool.checked,
      checkboxId: this.checkboxId
    });
}
